import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sidebar-videos",
  "use": "icon-sidebar-videos-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sidebar-videos\"><path d=\"M84.48 724.48h852.48V128H84.48v596.48zM0 128c0-46.08 38.4-84.48 84.48-84.48h852.48c48.64 0 87.04 38.4 87.04 84.48v596.48c0 46.08-38.4 84.48-84.48 84.48H84.48C38.4 808.96 0 770.56 0 724.48V128z\" /><path d=\"M468.48 724.48h84.48v212.48h-84.48V724.48z\" /><path d=\"M299.52 896h427.52v84.48H299.52V896zm89.6-588.8v230.4l245.76-122.88z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol